const CustomEvents = {
    setToInput: (inputId, value) => {
        const queryInput = document.getElementById(inputId);
        Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set.call(queryInput, value);
        queryInput.dispatchEvent(new Event("change", { bubbles: true }));
    },
};
export default CustomEvents;
